import ContactSection from "./componets/ContactSection";
import Footer from "./componets/Footer";
import Header from "./componets/Header";
import Hero from "./componets/Hero";
import HowThisWorks from "./componets/HowThisWorks";
import PrivacyPolicy from "./componets/PrivacyPolicy";

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <HowThisWorks />
      <ContactSection />
      <PrivacyPolicy />
      <Footer />
    </div>
  );
}

export default App;
